'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifierPropType = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var PrimitiveTypes = {
  localeUtils: _propTypes2["default"].shape({
    formatMonthTitle: _propTypes2["default"].func,
    formatWeekdayShort: _propTypes2["default"].func,
    formatWeekdayLong: _propTypes2["default"].func,
    getFirstDayOfWeek: _propTypes2["default"].func
  }),
  range: _propTypes2["default"].shape({
    from: _propTypes2["default"].instanceOf(Date),
    to: _propTypes2["default"].instanceOf(Date)
  }),
  after: _propTypes2["default"].shape({
    after: _propTypes2["default"].instanceOf(Date)
  }),
  before: _propTypes2["default"].shape({
    before: _propTypes2["default"].instanceOf(Date)
  })
};

var ModifierPropType = exports.ModifierPropType = _propTypes2["default"].oneOfType([PrimitiveTypes.after, PrimitiveTypes.before, PrimitiveTypes.range, _propTypes2["default"].func, _propTypes2["default"].array]);

exports["default"] = PrimitiveTypes;